import { UploadOutlined } from "@ant-design/icons";
import { Button, DatePicker, Input, notification, Upload } from "antd";
import to from "await-to-js";
import dayjs from "dayjs";
import { t } from "i18next";
import { useContext } from "react";

import { RcFile } from "antd/es/upload";
import { Modal } from "../../../../../../../../components/Modal/Modal";
import { ModalsContext } from "../../../../../../../../context/modals.context";
import { DATE_FORMAT } from "../../../../../../../../core/constants";
import { MinistryContext } from "../../../../../../../../modules/ministry/ministry.context";
import { ministryService } from "../../../../../../../../modules/ministry/ministry.service";
import { MAX_UPLOAD_SIZE } from "../../../../../../../../modules/obligee/exciseLicences/exciseLicences.constants";
import { exciseWarehouseService } from "../../../../../../../../modules/obligee/exciseWarehouse/exciseWarehouse.service";
import {
  arrayBufferToBase64,
  downloadFile,
} from "../../../../../../../../utils/fileDownload";
import { toastService } from "../../../../../../../../utils/toast.service";
import style from "./LicenceModal.module.scss";

export const LicenceModal = () => {
  const { isModalVisible, clearModals, setError } = useContext(ModalsContext);
  const { ministry, setMinistry, clearMinistryState } =
    useContext(MinistryContext);

  const dozvolaZahtevId = ministry.detaljiOSkladistu.dozvolaZahtevId;

  const handleCancel = () => {
    clearModals();
    clearMinistryState();
  };

  const createMfIzdavanjeResenjaOOduzimanju = async () => {
    const [err, res] = await to(
      ministryService.createMfIzdavanjeResenjaOOduzimanju({
        dozvolaZahtevId: dozvolaZahtevId,
        brojResenja: ministry.brojResenja,
        datumVazenja: ministry.datumVazenja,
        dokumentResenja: ministry.dokumentResenja,
      })
    );
    if (err || !res.success) return setError(res?.errorMessage);
    toastService.success(
      "TOAST.RESENJE_O_ODUZIMANJU_AKCIZNE_DOZVOLE_JE_USPESNO_IZDATO"
    );
    return setMinistry({
      updatedZahtevStatusId: res.data,
    });
  };

  const handleUpload = (event: any) => {
    if (event.file instanceof File) {
      const reader = new FileReader();
      reader.readAsArrayBuffer(event.file);
      const type = event.file.type;
      const formatType = () => {
        const parts = event.file.name.split(".");
        if (parts.length > 1) {
          return parts[parts.length - 1];
        } else {
          return type;
        }
      };
      reader.onloadend = (event) => {
        if (event.target?.result) {
          const data = event.target?.result;
          const obj = {
            data: arrayBufferToBase64(data as ArrayBuffer),
            format: formatType(),
          };
          setMinistry({ dokumentResenja: obj });
        }
      };
    }
  };
  const createGenerisanjeDozvolaDokumenta = async () => {
    const params = {
      resenjeId: ministry.updatedZahtevStatusId,
      dozvolaZahtevId: dozvolaZahtevId,
      tipResenja: 3,
    };
    const [err, res] = await to(
      exciseWarehouseService.createGenerisanjeDozvolaDokumenta(params)
    );
    if (err || !res.success) return setError(res?.errorMessage);
    toastService.success("TOAST.DOWNLOAD_SUCCESS");
    downloadFile(res.data.content, "resenje", "pdf");
  };

  function beforeUpload(file: RcFile) {
    const isPDF = file.type === "application/pdf" || file.name.endsWith(".pdf");
    if (!isPDF) {
      notification.error({ message: t("COMMON.FILE_TYPE_PDF") });
      return true;
    }

    if (file.size > MAX_UPLOAD_SIZE) {
      notification.error({ message: t("COMMON.FILE_SIZE") });
      return true;
    }

    return false;
  }

  return (
    <Modal
      name="licence-modal"
      title={t("COMMON.ODUZIMANJE_DOZVOLE_SKLADISTA")}
      footer={false}
      width="30%"
      onCancel={handleCancel}
      open={isModalVisible("licence")}
    >
      <div className={style.mainContainer}>
        <div>
          <h4 className="colorWarning mt-20">
            {t("COMMON.LICENCE_MODAL_PORUKA")}
          </h4>
          <div>
            <span style={{ color: "red" }}>*</span>
            &nbsp;
            <Upload
              maxCount={1}
              accept=".pdf"
              onChange={handleUpload}
              beforeUpload={beforeUpload}
              customRequest={() => {}}
            >
              <Button className={style.uploadButton} icon={<UploadOutlined />}>
                {t("AKCIZNE_MARKICE.DODAJ")}
              </Button>
            </Upload>
          </div>
          <div>
            <span style={{ color: "red" }}>*</span>
            &nbsp;
            <Input
              allowClear
              value={ministry.brojResenja}
              className="w-50 mt-20"
              onChange={(event) =>
                setMinistry({ brojResenja: event?.target.value })
              }
              name="broj-resenja-ministarstvo"
              placeholder={t("PLACEHOLDERS.BROJ_RESENJA")}
            />
          </div>
          <div>
            <span style={{ color: "red" }}>*</span>
            &nbsp;
            <DatePicker
              allowClear
              defaultValue={dayjs().add(1, "day")}
              className="w-50 mt-20"
              showToday={false}
              onChange={(value) => setMinistry({ datumVazenja: value })}
              format={DATE_FORMAT}
              value={
                ministry.datumVazenja ? dayjs(ministry.datumVazenja) : null
              }
              placeholder={t("PLACEHOLDERS.DATUM_VAZENJA")}
              name="datum-vazenja-ministarstvo"
            />
          </div>
        </div>
        <div className={style.buttonContainer}>
          <Button
            type="primary"
            onClick={() => createGenerisanjeDozvolaDokumenta()}
          >
            {t("COMMON.PREUZMI_FORMU")}
          </Button>
          <Button
            type="primary"
            className="ml-15"
            onClick={() => createMfIzdavanjeResenjaOOduzimanju()}
          >
            {t("COMMON.IZDAJ_RESENJE")}
          </Button>
          <Button
            type="primary"
            className="ml-15"
            onClick={() => handleCancel()}
          >
            {t("COMMON.ZATVORI")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
